import React from 'react';
import PluginItem from './PluginItem';
import './theme.css';

class PluginList extends React.Component {
  constructor(props)
  {
    super(props);
    /*this.PluginItems = props.data.map((d) =>
      <PluginItem key={d.id}
                 Name={d.name}
                 Desc={d.description}
                 Img1={d.img1}
                 Img2={d.img2}
                 Url={d.url}
                 LastUpdate={d.lastUpdate.split("T")[0]} />
    );*/
  }

  render(){

    this.PluginItems = this.props.data.map((d) =>
      <PluginItem key={d.id}
                 Name={d.name}
                 Desc={d.description}
                 Img1={d.img1}
                 Img2={d.img2}
                 Url={d.url}
                 LastUpdate={d.lastUpdate.split("T")[0]} />
    );

    return(
      <div className="ablak">
        <h3>Plugin downloads</h3>
        {this.PluginItems}
        <div className="keret szovegdoboz">
          More to come...
        </div>
      </div>
    );
  }

}

export default PluginList;



// WEBPACK FOOTER //
// ./src/Component/PluginList.js